module.exports = __webpack_public_path__ + "img/P150T_weapon_36.b5f6d3ce.png";